import { Flex, Heading, Text } from "@chakra-ui/react";
import { useTranslations } from "contexts/LocalizationContext";
import type { BestByRegionProps } from "../../types";
import { isBestAirlineByRegion } from "../../utils";
import Card from "../BestAirlines/Card";
import ScoreTag from "../ScoreTag";
import { localizeAirportName } from "../../AirportRanking/utils";

export const BestByRegion = ({ regionScore, scoresType }: BestByRegionProps) => {
  const translations = useTranslations();
  return (
    <Card>
      <Heading variant="h3" as="h3" mb={5}>
        {translations(`best_${scoresType}_by_region`)}
      </Heading>
      {regionScore.map((regionScoreItem) => {
        let score: number;
        let name: string;
        let region: string;
        let code: string;

        if (isBestAirlineByRegion(regionScoreItem)) {
          const { score: airlineScore, airline, region: regionName } = regionScoreItem;
          score = airlineScore;
          name = airline;
          region = regionName;
        }

        if (!isBestAirlineByRegion(regionScoreItem)) {
          const { score: airportScore, airport, region: regionName, airport_code: airportCode } = regionScoreItem;
          score = airportScore;
          name = airport;
          region = regionName;
          code = airportCode;
        }

        return (
          <Flex
            key={region}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", lg: "center" }}
            fontSize="sm"
            borderBottom="1px"
            borderColor="greyscale.300"
            py={4}
            position="relative"
            _last={{ borderBottom: "none", pb: 0 }}
          >
            <Flex w="full">
              <Text fontSize="sm" flexBasis={{ base: "44%", md: "43%", lg: "42%" }}>
                {translations(region)}
              </Text>
              {name && (
                <Text textAlign="left" fontSize="sm" flexBasis={{ base: "40%", md: "50%", lg: "40%" }}>
                  {(code && localizeAirportName(code, name, translations)) || name}
                </Text>
              )}
            </Flex>
            <ScoreTag index={0} score={score} />
          </Flex>
        );
      })}
    </Card>
  );
};
